import { render, staticRenderFns } from "./AcademicActivities.vue?vue&type=template&id=63aff4bf&scoped=true"
import script from "./AcademicActivities.vue?vue&type=script&lang=js"
export * from "./AcademicActivities.vue?vue&type=script&lang=js"
import style0 from "./AcademicActivities.vue?vue&type=style&index=0&id=63aff4bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aff4bf",
  null
  
)

export default component.exports